module.exports = __webpack_public_path__ + "static/media/block.59938b3b.png";